export enum WorkflowFilterType {
  Contains,
  ContainsNot,
}

export const WorkflowFilterTypeLabels: { [key: string]: string } = {
  [WorkflowFilterType.Contains]: 'ist in Auswahl',
  [WorkflowFilterType.ContainsNot]: 'ist nicht in Auswahl'
}
